import { api } from "@api/api";
import { IntegrationEndpoint } from "@modules/erpIntegrations/types";
import { EndpointFormValues } from "@modules/erpIntegrations/validations";

export async function createEndpointService(
  data: EndpointFormValues
): Promise<IntegrationEndpoint> {
  const { data: endpoint } = await api.post<IntegrationEndpoint>(
    "/v1/integration_endpoint_admin/",
    data
  );

  return endpoint;
}
